export default __webpack_public_path__ + "static/media/Select_all.4a223eb2.svg";